<template>
<div class="shopMobStar">
    <div class="titleBox" v-show="setting.isdisplaytitle === 1 || setting.isdisplayall">
        <div class="title"><span v-show="setting.isdisplaytitle === 1">{{setting.titlename}}</span></div>
        <div class="checkMore" v-show="setting.isdisplayall">查看更多</div>
    </div>
    <!-- 详细 -->
    <div class="detail" v-if="setting.liststyle === 'detail'">
        <div class="starItem" v-for="(item, index) in setting.datalist" :key="index">
            <div class="imgBox">
                <img v-lazy="item.furl" alt="">
            </div>
            <div class="msgBox">
                <p class="title no-wrap">{{item.objectname}}</p>
                <p class="desc no-wrap">{{item.description}}</p>
                <div class="bottomBox">
                    <div class="left">
                        <div class="sourceBox">
                        <!-- <div class="knowledge">知识</div> -->
                        <!-- <div class="activity">活动</div> -->
                        </div>
                        <div class="viewCount">
                            <img src="../../../../../common/images/shop/peoples.png" alt="">
                            <span>{{item.viewcount}}</span>
                        </div>
                        <div class="data">
                            <img src="../../../../../common/images/shop/data.png" alt="">
                            <span>{{item.viewcount}}</span>
                        </div>
                    </div>
                    <el-button type="primary">加入</el-button>
                </div>
            </div>
        </div>
    </div>
    <!-- 大图 -->
    <div class="bigimage" v-if="setting.liststyle === 'bigimage'">
        <div class="starItem" v-for="(item, index) in setting.datalist" :key="index">
            <div class="imgBox">
                <img v-lazy="item.furl" alt="">
                <div class="source">
                    <!-- <div class="knowledge">知识</div> -->
                    <!-- <div class="activity">活动</div> -->
                </div>
                <div class="viewAndData">
                    <div class="viewCount">
                        <img src="../../../../../common/images/shop/view-white.png" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                    <div class="data">
                        <img src="../../../../../common/images/shop/data-white.png" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                </div>
            </div>
            <div class="msgBox">
                <p class="title no-wrap">{{item.objectname}}</p>
                <p class="desc">
                   <span class="descText">{{item.description}}</span>
                </p>
            </div>
        </div>
    </div>
    <!-- 小图 -->
    <div class="smallimage" v-if="setting.liststyle === 'smallimage'">
        <div class="starItem" v-for="(item, index) in setting.datalist" :key="index">
            <div class="imgBox">
                <img v-lazy="item.furl" alt="">
                <div class="source">
                    <!-- <div class="knowledge">知识</div> -->
                    <!-- <div class="activity">活动</div> -->
                </div>
                <div class="viewAndData">
                    <div class="viewCount">
                        <img src="../../../../../common/images/shop/peoples-white.png" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                    <div class="data">
                        <img src="../../../../../common/images/shop/data-white.png" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                </div>
            </div>
            <p class="title">
                <span class="titleText">{{item.objectname}}</span>
            </p>
            <div class="joinBox">
                <el-button type="primary">加入</el-button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getStarList} from 'api/shop'
import $ from 'jquery'
export default {
    name: 'shopMobStar',
    data() {
        return {
            liststyle: 'bigimage'
        }
    },
    props: ['setting'],
    mounted() {
        // if (this.$route.query.model === '1') {
            this._getStarList()
        // }
    },
    updated() {
        // console.log(this.setting)
    },
    methods: {
        _getStarList(){
            this.setLoading(true)
            getStarList({
                data: {
                    startype: '',
                    starname: '',
                    page: 1,
                    pageSize: 2
                },
                success: data => {
                    let tmp = []
                    data.data.forEach(obj => {
                        tmp.push({
                            objectid: obj.kmcinnerid,
                            objectname: obj.kmcname,
                            kmctype: 3,
                            viewcount: obj.viewcount,
                            uprice: 0,
                            saleprice: 0,
                            furl: obj.logoPic.furl,
                            desc: ''
                        })
                    })
                    let tmpList = $.extend(true, [], this.shopMob)
                    tmpList.forEach((obj,index) => {
                        if (obj.comtype === 'star') {
                            obj.datalist = tmp
                        }
                    })
                    this.setShopMob(tmpList)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setShopMob',
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['shopMob'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
@import "~common/scss/mixin";
.shopMobStar {
    width: 100%;
    padding: 0.64rem;
    background: #fff;
    box-sizing: border-box;
    min-height: 227px;
    // border: 1px solid #ccc;
    .titleBox{
        @include flexBox(space-between);
        height: 0.84rem;
        .title{
            font-size:0.68rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            span{
                font-weight: 600;
            }
        }
        .checkMore{
            font-size: 0.46rem;
            color: #909399;
        }
    }
    // 详细
    .detail{
        .starItem{
            margin-top: 0.64rem;
            @include flexBox('');
            align-items: flex-start;
            .imgBox{
                img{
                    width:4.66rem;
                    height:2.76rem;
                }
            }
            .msgBox{
                margin-left: 0.32rem;
                .title{
                    font-size: 0.56rem;
                    width: 8.74rem;
                    font-weight: 500;
                    // margin-top: 6px;
                }
                .desc{
                    font-size: 0.48rem;
                    width: 8.74rem;
                    height: 0.6rem;
                    color: #909399;
                    margin-top: 8px;
                }
                .bottomBox{
                    @include flexBox(space-between);
                    margin-top: 0.52rem;
                    .left{
                        @include flexBox('')
                    }
                    .sourceBox{
                        div{
                            width:1.44rem;
                            height:0.76rem;
                            text-align: center;
                            line-height: 0.76rem;
                            color: #fff;
                            margin-right: 0.08rem;
                            font-size: 0.48rem;
                        }
                        .knowledge{
                            background: #67C23A;
                        }
                        .activity{
                            background: #E6A23C;
                        }
                    }
                    .viewCount,.data{
                        font-size: 0.46rem;
                        margin-right: 0.08rem;
                        @include flexBox('');
                        img{
                            width:0.48rem;
                            height:0.48rem;
                        }
                        span{
                            color: #909399;
                            font-size: 0.48rem;
                        }
                    }
                    .el-button{
                        font-size:0.48rem;
                        width:2.56rem;
                        height:0.8rem;
                        min-width: 2.56rem;
                        margin-left: 1.54rem;
                    }
                }
            }
        }
    }
    // 大图
    .bigimage{
        .starItem{
            margin-top: 0.64rem;
            box-shadow:0 0.08rem 0.24rem 0 rgba(0,0,0,0.21);
            border-radius:0.08rem;
            box-sizing: border-box;
            width: 13.72rem;
            padding-bottom: 0.64rem;
            .imgBox{
                position: relative;
                img{
                    width: 13.72rem;
                    height: 8.14rem;
                }
                .source{
                    div{
                        width: 1.44rem;
                        height: 0.76rem;
                        color: #fff;
                        text-align: center;
                        line-height: 0.76rem;
                        position: absolute;
                        top: 0;
                    }
                    .knowledge{
                        background: #67C23A;
                    }
                    .activity{
                        background: #E6A23C;
                    }
                }
                .viewAndData{
                    @include flexBox(space-between);
                    position: absolute;
                    bottom: 0.32rem;
                    width: 13.72rem;
                    box-sizing: border-box;
                    padding: 0 0.32rem;
                    div{
                        // flex: 1;
                        color: #fff;
                        img{
                            width: 0.48rem;
                            height: 0.48rem;
                        }
                    }
                }
            }
            .msgBox{
                .title{
                    width: 13.08rem;
                    font-size: 0.56rem;
                    font-weight: 500;
                    margin: 0.32rem auto 0.16rem;
                }
            }
            .desc{
                font-size: 0.48rem;
                color: #909399;
                width: 13.08rem;
                height: 1.2rem;
                max-height: 1.2rem;
                line-height: 0.6rem;
                margin: auto;
                overflow: hidden;
                .descText {
                    float: right;
                    /* "margin-left"要等于".wrap::before"的宽度 */
                    margin-left: -10px;
                    width: 13.08rem;
                    word-break: break-all;
                    font-size: 0.48rem;
                    // height: 1.44rem;
                    // line-height: 0.722rem;
                    font-weight: 400;
                    // font-weight: 600;
                }
                &::before {
                    float: left;
                    content: '';
                    width: 10px;
                    height: 100%;
                }
                &::after {
                    float: right;
                    content: "...";
                    /* 行高与".wrap"设置的一致即可 */
                    height: 1.2rem;
                    line-height: 0.6rem;
                    /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                    width: 37px;
                    margin-left: -37px;
                    /* 移动省略号位置 */
                    position: relative;
                    left: 100%;
                    bottom: 0.6rem;
                    font-weight: 600;
                    // text-align: center;
                    /* "padding"左右总和的值要小于等于".wrap::before"的宽度，但不能为0 */
                    padding-right: 1px;
                    // padding-left: 9px;
                    /*省略号左方的渐变色*/
                    background: #fff;
                    // background: linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -moz-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -o-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -ms-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(white), color-stop(20%, white));
                }
            }
        }
    }
    // 小图
    .smallimage{
        display: flex;
        flex-wrap: wrap;
        .starItem:nth-of-type(odd) {
            margin-right: 0.50rem;
        }
        .starItem{
            width: 6.5rem;
            margin-top: 0.64rem;
            box-shadow:0 0.08rem 0.24rem 0 rgba(0,0,0,0.21);
            border-radius:0.08rem;
            box-sizing: border-box;
            padding-bottom: 0.64rem;
            .imgBox{
                position: relative;
                img{
                    width: 100%;
                    height: 3.88rem;
                }
                .source{
                    div{
                        position: absolute;
                        top: 0;
                        width: 1.44rem;
                        height: 0.76rem;
                        color: #fff;
                        text-align: center;
                        line-height: 0.76rem;
                    }
                    .knowledge{
                        background: #67C23A;
                    }
                    .activity{
                        background: #E6A23C;
                    }
                }
                .viewAndData{
                    @include flexBox(space-between);
                    position: absolute;
                    bottom: 0.16rem;
                    width: 6.54rem;
                    padding: 0 0.24rem;
                    box-sizing: border-box;
                    color: #fff;
                    div{
                        img{
                            width: 0.48rem;
                            height: 0.48rem;
                        }
                    }
                }
            }
            .title{
                font-size: 0.56rem;
                width: 6.06rem;
                height: 1.68rem;
                line-height: 0.84rem;
                margin: 0.24rem auto 0.8rem;
                overflow: hidden;
                .titleText {
                    float: right;
                    /* "margin-left"要等于".wrap::before"的宽度 */
                    margin-left: -10px;
                    width: 6.06rem;
                    word-break: break-all;
                    font-size: 0.48rem;
                    // height: 1.44rem;
                    // line-height: 0.722rem;
                    font-weight: 500;
                    // font-weight: 600;
                }
                &::before {
                    float: left;
                    content: '';
                    width: 10px;
                    height: 100%;
                }
                &::after {
                    float: right;
                    content: "...";
                    /* 行高与".wrap"设置的一致即可 */
                    height: 1.68rem;
                    line-height: 0.84rem;
                    /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                    width: 37px;
                    margin-left: -37px;
                    /* 移动省略号位置 */
                    position: relative;
                    left: 106%;
                    bottom: 0.8rem;
                    font-weight: 600;
                    // text-align: center;
                    /* "padding"左右总和的值要小于等于".wrap::before"的宽度，但不能为0 */
                    padding-right: 1px;
                    // padding-left: 9px;
                    /*省略号左方的渐变色*/
                    background: #fff;
                    // background: linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -moz-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -o-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -ms-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                    // background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(white), color-stop(20%, white));
                }
            }
            .joinBox{
                text-align: center;
                .el-button{
                    width: 2.56rem;
                    height: 0.8rem;
                    min-width: 2.56rem;
                    font-size: 0.48rem;
                }
            }
        }
    }
}
</style>
